import FleetTitle from '@/libs/antd/components/Title';
import dayjs from 'dayjs';
import { Col, Row, Space } from 'antd';
import { LKLabel, LKText } from './LKComponents';

type CallReportContact = {
	id: number;
	prospectId: null | string;
	name: string;
	position: string;
	companyName: string;
	phoneNumber: string;
};

type CallReportConfirmation = {
	id: number;
	confirmationPoint: string;
	confirmationDetail: string;
};

type CallReportDetailData = {
	confirmationDate?: string;
	confirmationMedia?: { value: string };
	additionalInformation?: string;
	surveyCallConfirmations?: CallReportConfirmation[];
};

export type CallReportPdfData = {
	mainInformation?: { customerName?: string };
	surveyCallContacts?: CallReportContact[];
	surveyCallReportDetail?: CallReportDetailData;
};

const CallReportPdfDetail = ({ data }: { data: CallReportPdfData }) => {
	const {
		mainInformation,
		surveyCallContacts = [],
		surveyCallReportDetail,
	} = data ?? {};
	const {
		confirmationDate,
		confirmationMedia,
		additionalInformation,
		surveyCallConfirmations = [],
	} = surveyCallReportDetail ?? {};

	return (
		<div id="call-report-pdf-content">
			<div style={{ padding: '10px', fontSize: '8px' }}>
				<FleetTitle level={3}>
					<div style={{ textAlign: 'center' }}>Call Report</div>
				</FleetTitle>
				<Row
					gutter={[16, 16]}
					style={{ marginTop: 10 }}
				>
					<Col span={12}>
						<Space
							direction="vertical"
							size={1}
							style={{ width: '100%' }}
						>
							<Row>
								<Col span={10}>
									<LKLabel>Nama Customer</LKLabel>
								</Col>
								<Col span={14}>
									<LKText>{mainInformation?.customerName}</LKText>
								</Col>
							</Row>
							<Row>
								<Col span={10}>
									<LKLabel>Tanggal Konfirmasi</LKLabel>
								</Col>
								<Col span={14}>
									<LKText>
										{confirmationDate
											? dayjs(confirmationDate).format('DD/MM/YYYY')
											: '-'}
									</LKText>
								</Col>
							</Row>
							<Row>
								<Col span={10}>
									<LKLabel>Media Konfirmasi</LKLabel>
								</Col>
								<Col span={14}>
									<LKText>{confirmationMedia?.value ?? '-'}</LKText>
								</Col>
							</Row>
							<Row>
								<Col span={10}>
									<LKLabel>Additional Information</LKLabel>
								</Col>
								<Col span={14}>
									<LKText>{additionalInformation ?? '-'}</LKText>
								</Col>
							</Row>
						</Space>
					</Col>
				</Row>

				<div style={{ marginTop: 20 }}>
					<LKLabel>Pihak Yang Hadir</LKLabel>
					<table
						style={{
							width: '100%',
							fontSize: 10,
							borderCollapse: 'collapse',
						}}
					>
						<thead>
							<tr>
								<th style={{ border: '1px solid #000', padding: 2 }}>Nama</th>
								<th style={{ border: '1px solid #000', padding: 2 }}>
									Jabatan
								</th>
								<th style={{ border: '1px solid #000', padding: 2 }}>
									Perusahaan
								</th>
								<th style={{ border: '1px solid #000', padding: 2 }}>
									No Telepon
								</th>
							</tr>
						</thead>
						<tbody>
							{surveyCallContacts.map((c: CallReportContact, idx: number) => (
								<tr key={idx}>
									<td
										style={{
											border: '1px solid #000',
											padding: 2,
										}}
									>
										{c.name}
									</td>
									<td
										style={{
											border: '1px solid #000',
											padding: 2,
										}}
									>
										{c.position}
									</td>
									<td
										style={{
											border: '1px solid #000',
											padding: 2,
										}}
									>
										{c.companyName}
									</td>
									<td
										style={{
											border: '1px solid #000',
											padding: 2,
										}}
									>
										{c.phoneNumber}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div style={{ marginTop: 20 }}>
					<LKLabel>Poin Konfirmasi</LKLabel>
					<table
						style={{
							width: '100%',
							fontSize: 10,
							borderCollapse: 'collapse',
						}}
					>
						<thead>
							<tr>
								<th style={{ border: '1px solid #000', padding: 2 }}>Poin</th>
								<th style={{ border: '1px solid #000', padding: 2 }}>Detail</th>
							</tr>
						</thead>
						<tbody>
							{surveyCallConfirmations.map(
								(c: CallReportConfirmation, idx: number) => (
									<tr key={idx}>
										<td
											style={{
												border: '1px solid #000',
												padding: 2,
											}}
										>
											{c.confirmationPoint}
										</td>
										<td
											style={{
												border: '1px solid #000',
												padding: 2,
											}}
										>
											{c.confirmationDetail}
										</td>
									</tr>
								),
							)}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default CallReportPdfDetail;
